import { Link } from 'react-router-dom'

import { useAuth } from '../../../../context/AuthContext'

interface HomeBannerProps {
  message?: boolean
}

export const HomeBanner = ({ message }: HomeBannerProps) => {
  const { isAuthenticated, signIn } = useAuth()

  const handleCreateClick = (e: React.MouseEvent) => {
    if (!isAuthenticated && signIn) {
      e.preventDefault()
      signIn()
    }
  }

  return (
    <section
      style={{
        width: '100vw',
        minWidth: '100vw',
        height: 650,
        position: 'relative',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        background: 'var(--dark-brown)',
        borderRadius: 0,
        zIndex: 1,
      }}
    >
      {/* Hero Background Image */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: 'url(/images/Hero-image_LE_upscale_balanced.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }}
        aria-hidden="true"
      />

      {/* Centered Content Container */}
      <div
        style={{
          position: 'relative',
          maxWidth: '1280px',
          margin: '0 auto',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '0 80px',
          zIndex: 2,
        }}
      >
        {/* Hero Card */}
        {message && (
          <div
            style={{
              width: '576px',
              maxWidth: '90vw',
              padding: '40px',
              background: 'var(--cream-bg)',
              boxShadow: 'var(--shadow-hero)',
              borderRadius: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              textAlign: 'left',
            }}
          >
            <h1
              style={{
                margin: '0 0 24px 0',
                fontSize: '3rem',
                fontWeight: 700,
                fontFamily: 'var(--font-heading)',
                color: 'var(--dark-brown)',
                letterSpacing: '-0.01em',
                lineHeight: 1.2,
              }}
            >
              Discover Your Next Creation
            </h1>
            <p
              style={{
                fontSize: '1.125rem',
                color: 'var(--medium-brown)',
                margin: '0 0 32px 0',
                fontWeight: 400,
                fontFamily: 'var(--font-body)',
                lineHeight: 1.6,
              }}
            >
              Join a global community to discover, share, and create beautiful craft projects. Browse free sewing,
              knitting, beadwork, and felt patterns from makers worldwide.
            </p>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <Link
                to="/search"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '12px 24px',
                  background: 'var(--primary-teal)',
                  color: 'var(--white)',
                  borderRadius: 9999,
                  fontWeight: 700,
                  fontSize: '1rem',
                  fontFamily: 'var(--font-body)',
                  textDecoration: 'none',
                  boxShadow: 'var(--shadow-button)',
                  transition: 'all 0.2s',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'var(--primary-teal-hover)'
                  e.currentTarget.style.transform = 'translateY(-2px)'
                  e.currentTarget.style.boxShadow = '0 12px 20px rgba(0, 0, 0, 0.15)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'var(--primary-teal)'
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'var(--shadow-button)'
                }}
              >
                Explore Patterns
              </Link>
              <Link
                to={isAuthenticated ? '/create' : '#'}
                onClick={handleCreateClick}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '12px 24px',
                  background: 'var(--primary-teal)',
                  color: 'var(--white)',
                  borderRadius: 9999,
                  fontWeight: 700,
                  fontSize: '1rem',
                  fontFamily: 'var(--font-body)',
                  textDecoration: 'none',
                  boxShadow: 'var(--shadow-button)',
                  transition: 'all 0.2s',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'var(--primary-teal-hover)'
                  e.currentTarget.style.transform = 'translateY(-2px)'
                  e.currentTarget.style.boxShadow = '0 12px 20px rgba(0, 0, 0, 0.15)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'var(--primary-teal)'
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'var(--shadow-button)'
                }}
              >
                Join Community
              </Link>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
